export default __webpack_public_path__ + "static/media/slogan-2.6f298347.svg";